import { render, staticRenderFns } from "./White.vue?vue&type=template&id=e70b81d0&scoped=true&"
import script from "./White.vue?vue&type=script&lang=js&"
export * from "./White.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=e70b81d0&prod&scoped=true&lang=css&"
import style1 from "./White.vue?vue&type=style&index=1&id=e70b81d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70b81d0",
  null
  
)

export default component.exports